// current page styles
import '../../blocks_fss/page/page.less';
import './finders-surge-selector.less';

// svg sprite icons
import '../../images-svg-sprite/chevron.svg';
import '../../images-svg-sprite/chevron2.svg';
import '../../images-svg-sprite/chevron_mob.svg';
import '../../images-svg-sprite/mobile-loop.svg';
import '../../images-svg-sprite/close_regular.svg';

import '../../images-svg-sprite/attention.svg';

import '../../images-svg-sprite/filter-white.svg';
import '../../images-svg-sprite/filter-black.svg';

// plugs
import '../../images-svg-sprite/plugs/CS8364C.svg';
import '../../images-svg-sprite/plugs/IEC-320_C13.svg';
import '../../images-svg-sprite/plugs/IEC-320_C20.svg';
import '../../images-svg-sprite/plugs/NEMA_5-15P.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-20P.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-20P.svg';
import '../../images-svg-sprite/plugs/NEMA_L14-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_L15-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_L21-30P.svg';
import '../../images-svg-sprite/plugs/Schuko_CEE_7.svg';
import '../../images-svg-sprite/plugs/Schuko_CEE_7-7P.svg';
import '../../images-svg-sprite/plugs/Schuko_CEE_7_16.svg';
import '../../images-svg-sprite/plugs/Schuko_CEE_7_EU1-16p.svg';
import '../../images-svg-sprite/plugs/CLIPSAL_32A_56P332.svg';
import '../../images-svg-sprite/plugs/IEC_309_16A.svg';
import '../../images-svg-sprite/plugs/IEC_309_16A_2P+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_16A_3P+N+PE.svg';
import '../../images-svg-sprite/plugs/IEC_309_16A_3P+N+PE,_IEC_309_20A_3P+N+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_20A_3P+N+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_30A_3P+N+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_32A_2P+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_32A_3P+N+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_32A_3P+N+PE.svg';
import '../../images-svg-sprite/plugs/IEC_309_60A_3P+N+E.svg';
import '../../images-svg-sprite/plugs/IEC_309_60A_3P+PE.svg';
import '../../images-svg-sprite/plugs/CS8365.svg';
import '../../images-svg-sprite/plugs/Hubbell_CS8365C.svg';
import '../../images-svg-sprite/plugs/IEC-320_C14.svg';
import '../../images-svg-sprite/plugs/IEC-60320-C13.svg';
import '../../images-svg-sprite/plugs/IEC-60320-C19_20.svg';
import '../../images-svg-sprite/plugs/IEC_320_C13.svg';
import '../../images-svg-sprite/plugs/IEC_320_C19.svg';
import '../../images-svg-sprite/plugs/NEMA_5-15R.svg';
import '../../images-svg-sprite/plugs/NEMA_5-20P.svg';
import '../../images-svg-sprite/plugs/NEMA_5-20R.svg';
import '../../images-svg-sprite/plugs/NEMA_5-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_5-50P.svg';
import '../../images-svg-sprite/plugs/NEMA_5-50R.svg';
import '../../images-svg-sprite/plugs/NEMA_6-15P.svg';
import '../../images-svg-sprite/plugs/NEMA_6-15R.svg';
import '../../images-svg-sprite/plugs/NEMA_6-20P.svg';
import '../../images-svg-sprite/plugs/NEMA_6-20R.svg';
import '../../images-svg-sprite/plugs/NEMA_6-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_6-30R.svg';
import '../../images-svg-sprite/plugs/NEMA_6-50P.svg';
import '../../images-svg-sprite/plugs/NEMA_6-50R.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-15P.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-15R.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-20R.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_L5-30R.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-15P.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-15R.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-20R.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-30P.svg';
import '../../images-svg-sprite/plugs/NEMA_L6-30R.svg';
import '../../images-svg-sprite/plugs/NEMA_L14-30R.svg';
import '../../images-svg-sprite/plugs/NEMA_L21-20P.svg';
import '../../images-svg-sprite/plugs/Schuko_CEE_7___EU1-16P.svg';
import '../../images-svg-sprite/plugs/Unknown-Unlisted.svg';
import './surge-analytics';

// current page specific code
import FinderSearch from '../../blocks_fss/js-srp-mediator/js-finder-mediator';
import { handleCommaFormat, testForNumber } from '../../blocks_fss/js-helpers/js-helpers';

// require scripts from page (main common file)
require('../../blocks_fss/page/page.js');

$(document).ready(() => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isIE = /* @cc_on!@ */ false || !!document.documentMode;

    /* js-srp-mediator call */
    const currentMediator = document.querySelector('.js-srp-mediator-outer');
    if (currentMediator) {
        new FinderSearch('tools').init(currentMediator);
    }

    /* insert param from url string to search fields */
    const string = document.querySelector('.js-searched-phrase').value;
    const searchInputsCollection = document.querySelectorAll('.js-global-search__field');

    if (searchInputsCollection.length > 0) {
        const searchInputsArray = [...searchInputsCollection];

        searchInputsArray.forEach(item => {
            item.value = string;
        });
    }
    $(window).on('fetchEnd', () => {
        initializeRangeSlider();
        $('.js-range-slider').slider('enable');
        $('.range-slider__input').attr('disabled', false);
    });

    /* Initialize range ui component */

    let minValue;
    let maxValue;

    function initializeRangeSlider() {
        if (!$('.js-range-slider').length || $('.js-range-slider').slider('instance')) return;
        /* Setting min and max values */
        minValue = parseInt(document.querySelector('.range-slider__price_left').textContent, 10);
        maxValue = parseInt(document.querySelector('.range-slider__price_right').textContent, 10);
        const currentMinValue = parseInt(
            document.querySelector('.js-range-slider__minCost').value,
            10,
        );
        const currentMaxValue = parseInt(
            document.querySelector('.js-range-slider__maxCost').value,
            10,
        );

        $('.js-range-slider').slider({
            initialValues: [currentMinValue, currentMaxValue],
            min: minValue,
            max: maxValue,
            values: [currentMinValue, currentMaxValue],
            range: true,
            create: handleSlidersInit,
            stop: handleActivate,
            change: handleRequestSend,
            slide: handleActivate,
        });

        $('input.js-range-slider__minCost').change(handleMinChange);
        function handleMinChange() {
            const $this = $(this);
            let value1 = $this.val();
            const value2 = $this
                .parent()
                .find('input.js-range-slider__maxCost')
                .val();
            let numberWithoutComma;

            if (
                !value1 ||
                parseFloat(value1.replace(/,/g, '').trim()) >
                    parseFloat(value2.replace(/,/g, '').trim())
            ) {
                value1 = minValue;
                $this.val(value1);
                numberWithoutComma = value1.toString().replace(/,/g, '');
            } else {
                numberWithoutComma = value1.replace(/,/g, '');
            }

            $this
                .closest('.range-slider')
                .find('.js-range-slider')
                .slider('values', 0, numberWithoutComma);
        }

        $('input.js-range-slider__maxCost').change(handleMaxChange);
        function handleMaxChange() {
            const $this = $(this);
            const value1 = $this
                .parent()
                .find('input#minCost')
                .val();
            let value2 = $this.val();
            let numberWithoutComma;

            if (
                !value2 ||
                parseFloat(value2.replace(/,/g, '').trim()) <
                    parseFloat(value1.replace(/,/g, '').trim())
            ) {
                value2 = maxValue.toString();
                $this.val(maxValue);
                numberWithoutComma = value2.toString().replace(/,/g, '');
            } else {
                numberWithoutComma = value2.replace(/,/g, '');
            }

            if (parseFloat(value2.replace(/,/g, '').trim()) > maxValue) {
                value2 = maxValue;
                $this.val(handleCommaFormat(maxValue.toString()));
            }
            $this
                .closest('.range-slider')
                .find('.js-range-slider')
                .slider('values', 1, numberWithoutComma);
        }

        $('input.js-range-slider__maxCost, input.js-range-slider__minCost').change(
            handleInputUpdate,
        );

        // allow the user to input only numbers
        if (isIE || isFirefox) {
            $('.range-slider__input').on('keydown', function(e) {
                if (e.keyCode >= 37 && e.keyCode <= 40) return;
                if (e.ctrlKey && (e.key === 'v' || e.key === 'a' || e.key === 'c' || e.key === 'z'))
                    return;
                if (e.keyCode === 13 || e.keyCode === 9) {
                    $(this).trigger('change');
                    return;
                }
                if (e.keyCode === 8 || e.keyCode === 46) return;
                if (!testForNumber(e.key || e.originalEvent.data)) {
                    e.preventDefault();
                }
            });
        } else {
            $('.range-slider__input').on('input', function(e) {
                if (
                    e.originalEvent.inputType === 'deleteContentBackward' ||
                    e.originalEvent.inputType === 'deleteContentForward' ||
                    e.originalEvent.inputType === 'insertFromPaste'
                )
                    return;
                if (!testForNumber(e.key || e.originalEvent.data)) {
                    const data = $(this).val();
                    const filteredString = data
                        .split('')
                        .filter(testForNumber)
                        .join('');
                    $(this).val(filteredString);
                }
            });
        }

        if (isIE) {
            $('.range-slider__input').on('blur', function() {
                $(this).trigger('change');
            });
        }

        let shouldSanitize = false;
        $('.range-slider__input')
            .on('paste', () => {
                shouldSanitize = true;
            })
            .on('input', function() {
                if (!shouldSanitize) {
                    return;
                }
                const data = $(this).val();
                const filteredString = data
                    .split('')
                    .filter(testForNumber)
                    .join('');
                $(this).val(filteredString);
                shouldSanitize = false;
            });
    }

    initializeRangeSlider();

    function handleSlidersInit() {
        // sliders init
        const $this = $(this);
        $('.range-slider__price_left').text($this.slider('option', 'min'));
        const maxPrice = $this.slider('option', 'max');
        $('.range-slider__price_right').text(handleCommaFormat(maxPrice.toString()));

        // inputs init
        handleInputInit('js-range-slider__minCost', 0, $this);
        handleInputInit('js-range-slider__maxCost', 1, $this);
    }

    function handleInputInit(inputClassName, valueNumber, $this) {
        const currentValue = $this.slider('values', valueNumber);
        const convertedValue = handleCommaFormat(currentValue.toString());
        $(`.${inputClassName}`).val(convertedValue);
    }

    function handleActivate(event, ui) {
        const $this = $(this);
        handleHandlerSetUp(0, 'minCost', $this, ui);
        handleHandlerSetUp(1, 'maxCost', $this, ui);
    }

    function handleRequestSend() {
        const responseFromDataUrl = $(this)
            .next('.range-slider__inputs')
            .attr('data-url');

        const request = handleParseDataUrl.call(this, responseFromDataUrl);
        if (!request) return;
        const container = $(this)
            .closest('.js-filter-list__item')
            .get(0);

        const event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: request },
        });

        container.dispatchEvent(event);
        $(this).slider('disable');
        $('.range-slider__input').attr('disabled', true);
    }

    function handleParseDataUrl(url) {
        const secondItemPositionEnd = url.lastIndexOf('#');
        const secondItemPositionStart = url.lastIndexOf('#', secondItemPositionEnd - 1);
        const firstItemPositionEnd = url.lastIndexOf('#', secondItemPositionStart - 1);
        const firstItemPositionStart = url.lastIndexOf('#', firstItemPositionEnd - 1);

        const minValueFromDataUrl = url.substring(firstItemPositionStart, firstItemPositionEnd + 1);
        const maxValueFromDataUrl = url.substring(
            secondItemPositionStart,
            secondItemPositionEnd + 1,
        );

        const minRangeCurrentValue = $(this)
            .slider('values', 0)
            .toString();
        const maxRangeCurrentValue = $(this)
            .slider('values', 1)
            .toString();

        const [initialMinValue, initialMaxValue] = $(this).slider('option', 'initialValues');
        const convertedInitialMinValue = initialMinValue.toString();
        const convertedInitialMaxValue = initialMaxValue.toString();

        if (
            minRangeCurrentValue.concat(maxRangeCurrentValue) !==
            convertedInitialMinValue.concat(convertedInitialMaxValue)
        ) {
            return url
                .replace(minValueFromDataUrl, minRangeCurrentValue)
                .replace(maxValueFromDataUrl, maxRangeCurrentValue);
        }
        return null;
    }

    function handleHandlerSetUp(valueNumber, inpudId, $sliderElement, ui) {
        if (ui.handleIndex === 0) {
            handleValuesUpdate('minCost', ui.value);
        } else {
            handleValuesUpdate('maxCost', ui.value);
        }
    }

    function handleValuesUpdate(inputId, uiValue) {
        const formattedCost = handleCommaFormat(uiValue.toString());
        $(`input#${inputId}`).val(formattedCost);
    }

    function handleInputUpdate(event) {
        if (event.which >= 37 && event.which <= 40) return;

        $(this).val((index, value) =>
            value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        );
    }
});
